import { StatusOperationBookingType } from '../../../operations/conf/Data.conf';
import { OperationConf as Operation } from '../../../operations/conf/Create.conf';
import _ from 'lodash';
import * as yup from 'yup';
import { API as marina } from '../../../marina/api';
import { TypeServiceBunker } from '../Data.conf';

export const BunkerConf = {
  schema: {
    ..._.omit(Operation.schema, [
      'requested_date',
      'status_operation_booking',
      'id_marina',
      'service_place',
      'requested_service_generic',
    ]),
    service_time: yup.string().nullable().required('Time is required').test(
      'is-time',
      'Time format invalid',
      value => {
        if (!value) return true;
        return /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/.test(value);
      }
    ),
    id_marina: yup.object().nullable().required('Location is required'),
    service_place: yup
      .string()
      .nullable()
      .required('Location Details is required'),
    quantity_service_bunker: yup
      .string()
      .nullable()
      .required('Quantity is required'),
    type_service_bunker: yup.object().nullable().required('Type is required'),
  },
  defaultValues: {
    ..._.omit(Operation.defaultValues, [
      'requested_date',
      'status_operation_booking',
    ]),
    status_operation_booking: _.find(StatusOperationBookingType, {
      id: 'NEW REQUEST',
    }).id,
    service_place: null,
    quantity_service_bunker: null,
    type_service_bunker: null,
  },
  fields: [
    {
      id: 'service_time',
      name: 'service_time',
      type: 'time',
      label: 'Time',
      required: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'id_marina',
      name: 'id_marina',
      type: 'async_autocomplete',
      label: 'Location',
      api: marina.select,
      required: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'service_place',
      name: 'service_place',
      type: 'text',
      label: 'Location Details',
      required: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'quantity_service_bunker',
      name: 'quantity_service_bunker',
      type: 'text',
      label: 'Quantity (L)',
      required: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'type_service_bunker',
      name: 'type_service_bunker',
      type: 'autocomplete',
      label: 'Type',
      options: TypeServiceBunker,
      required: true,
      disableClearable: true,
      xs: 12,
      sm: 6,
    },
    ...Operation.fields.slice(5, 9),
    {
      id: 'status_operation_booking',
      name: 'status_operation_booking',
      type: 'select-custom',
      label: 'Status operation booking',
      required: true,
      options: StatusOperationBookingType,
      xs: 12,
      sm: 6,
    },
    ...Operation.fields.slice(10),
  ],
};
